import { ReducerCreators } from '@reduxjs/toolkit';

import { SuperAdminNotificationsState } from './types';
import { GetSuperAdminNotifications } from '@/connection/super-admin-notifications/get-super-admin-notifications';

export const reducers = (create: ReducerCreators<SuperAdminNotificationsState>) => ({
  getSuperAdminNotifications: create.asyncThunk(
    async () => {
      const superAdminNotifications = await GetSuperAdminNotifications();
      return superAdminNotifications;
    },
    {
      fulfilled: (state, action) => {
        state.superAdminNotifications = action.payload;
      },
    }
  ),
});
